  <div class="page-header-outer">
  <div class="page-header">
    <h1>
        Client Configuration
    </h1>
     <br>
      <h3>You are now viewing <b>{{this.selectedName}}</b> data.</h3> 
      <br>      
  </div>
</div>
<div class="content-inner"  [ngClass]="{'loading': initialLoading }">
<form #clientConfigurationEditForm="ngForm">
  <h2>Staff Management Tool Access</h2>
  <section>
  <div class="body">
      <div class="form-group">
        <label> <input type="checkbox" name="clientConfigurationInpatientNursingAccess" [(ngModel)]="selectedInpatientNursingAccess"/>Inpatient Nursing Access</label>
      </div>
      <div class="form-group">
        <label>  <input type="checkbox"  name="clientconfigurationNursingProceduralAncillaryAccess" [(ngModel)]="selectedNursingProceduralAncillaryAccess">Nursing, Procedural and Ancillary Access</label>
      </div>
      <div class="form-group">
          <label>Cost Center Limit</label>
          <input type="number"  required pattern = "[0-9][0-9]{0,2}" autocomplete="off"  min="0" max="999"  name="clientconfigurationcostcenterlimit" [(ngModel)]="selectedCostCenterLimit"/>
      </div>
      <div class="form-group">
        <label>  <input type="checkbox"  name="clientconfigurationDefaultReportAccesstoShiftLeaders" [(ngModel)]="selectedDefaultReportAccessToShiftLeaders">Grant Shift Leaders report access by default </label>
      </div>
  </div>
  <h2>Imports</h2>
  <div class="form-group">
    <label>  <input type="checkbox"  name="clientconfigurationAncillaryPatientUOS" [(ngModel)]="selectedAncillaryPatientUOS">Ancillary Patient UOS </label>
    <label>  <input type="checkbox"  name="clientconfigurationTimeAndAttendance" [(ngModel)]="selectedTimeAndAttendance">Time And Attendance </label>
  </div>
  <div class="form-buttons">
    <button class="primary" type="button" (click)="OnSave()" [disabled]="!clientConfigurationEditForm.form.valid || !clientConfigurationEditForm.dirty || getValidation()">
      <span class="icon-plus"></span> Save</button>
    <button class="cancel" type="button" (click)="onCancel()" [disabled]="!clientConfigurationEditForm.form.valid || !clientConfigurationEditForm.dirty" >
      <span class="icon-cancel"></span> Cancel</button>
  </div>
  </section>
</form>
<smt-modal [(isActive)]="defaultReportAccessToShiftLeadersModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true" 
(acceptEvent)="saveClientConfiguration()" (rejectEvent)="defaultReportAccessToShiftLeadersModalActive = false" 
acceptText="OK" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
<div role="body">
  {{ shiftLeadersAccessconfirmationMessage }} 
</div>
</smt-modal>
</div>
